<template>
    <page :tabs="tabs">
        <b-container fluid>
            <h6 class="my-3">Digital Signatures</h6>
            <b-form-group :description="enableDescription">
                <form-switch v-model="enable" />
                <label>Enable digital signatures</label>
            </b-form-group>
            <b-form-group
                v-if="enable"
                description="Require that the guest sign the rental agreement at the time of booking. This only applies to direct bookings."
            >
                <form-switch v-model="enableOnline" />
                <label>Enable digital signatures for online bookings</label>
            </b-form-group>
            <b-form-group
                v-if="enable"
                description="Allow the guest to sign the rental agreement using the guest app. All guests can use this regardless of booking source."
            >
                <form-switch v-model="enableGuestApp" />
                <label>Enable digital signatures for guest app</label>
            </b-form-group>
            <h6 class="my-3" v-if="enable">Notifications</h6>
            <b-form-group v-if="enable">
                <form-switch v-model="useDefaultEmail" />
                <label>Use default contact address</label>
                <form-group-email
                    v-if="enable && !useDefaultEmail"
                    :value="notificationEmail"
                    @input="saveNotificationEmail"
                    label="E-mail address for notifications"
                />
            </b-form-group>
            <b-form-group v-if="enable">
                <form-switch v-model="enableGuestViewNotification" />
                <label>Enable guest view document notification</label>
            </b-form-group>
            <b-form-group v-if="enable">
                <form-switch v-model="enableGuestSignNotification" />
                <label>Enable guest sign document notification</label>
            </b-form-group>
        </b-container>
    </page>
</template>

<script>
import Page from '../../generic/page/page.vue';
import FormSwitch from '../../generic/form-switch/form-switch.vue';
import FormGroupEmail from '../../generic/form-group-email/form-group-email.vue';
import { mapGetters } from 'vuex';
export default {
    name: 'DigitalSignatureSetup',
    components: {
        Page,
        FormSwitch,
        FormGroupEmail,
    },
    data() {
        return {
            notificationEmail: '',
        };
    },
    computed: {
        ...mapGetters('header', ['userCanUseUnlayer']),
        tabs() {
            const tabs = [
                {
                    title: 'Settings',
                    route: '/app/digital-signature/setup/',
                    active: true,
                },
                {
                    title: 'Requested Signatures',
                    route: '/app/digital-signature/list/',
                    active: false,
                },
                {
                    title: 'Pending Signatures',
                    route: '/app/digital-signature/pending/',
                    active: false,
                },
            ];
            if (this.userCanUseUnlayer) {
                tabs.push({
                    title: 'Assignments',
                    route: '/app/digital-signature/assignments/',
                    active: false,
                });
            }
            return tabs;
        },
        enable: {
            get() {
                return this.$store.getters['digitalSignature/enable'];
            },
            set(value) {
                this.saveSetting('enable', value);
            },
        },
        enableOnline: {
            get() {
                return this.$store.getters['digitalSignature/enableOnline'];
            },
            set(value) {
                this.saveSetting('enableOnline', value);
            },
        },
        enableGuestApp: {
            get() {
                return this.$store.getters['digitalSignature/enableGuestApp'];
            },
            set(value) {
                this.saveSetting('enableGuestApp', value);
            },
        },
        useDefaultEmail: {
            get() {
                return this.$store.getters['digitalSignature/useDefaultEmail'];
            },
            set(value) {
                this.saveSetting('useDefaultEmail', value);
                if (value) {
                    this.$store.dispatch('digitalSignature/set', {
                        key: 'notificationEmail',
                        value: '',
                    });
                    this.notificationEmail = '';
                }
            },
        },
        enableGuestViewNotification: {
            get() {
                return this.$store.getters['digitalSignature/enableGuestViewNotification'];
            },
            set(value) {
                this.saveSetting('enableGuestViewNotification', value);
            },
        },
        enableGuestSignNotification: {
            get() {
                return this.$store.getters['digitalSignature/enableGuestSignNotification'];
            },
            set(value) {
                this.saveSetting('enableGuestSignNotification', value);
            },
        },
        enableDescription() {
            if (this.enable) {
                return 'Signature requests must be emailed manually unless one or both of the following options are selected.';
            }
            return '';
        },
    },
    methods: {
        saveSetting(key, value) {
            (async () => {
                try {
                    await this.$store.dispatch('digitalSignature/save', {
                        key,
                        value,
                    });
                } catch (err) {
                    if (key !== 'notificationEmail') {
                        this.errorToast({ text: 'Could not save setting.' });
                    }
                }
            })();
        },
        saveNotificationEmail: function (value) {
            this.saveSetting('notificationEmail', value);
        },
    },
    mounted() {
        (async () => {
            try {
                await this.$store.dispatch('digitalSignature/fetch');
            } catch (err) {
                this.errorToast({ text: 'Could not fetch settings.' });
                return;
            }
            this.notificationEmail = this.$store.getters['digitalSignature/notificationEmail'];
        })();
    },
};
</script>
